import { createContext, useContext } from 'react';

export const PathContext = createContext<string>('');
export const usePathContext = (subPath = '') => {
	const basePath = useContext(PathContext);
	return joinPath(basePath, subPath);
};

export const joinPath = (...components: (string | undefined)[]) => components.filter((c) => !!c).join('.');
